import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Layout, Row } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
//Components
import { HisAcademico } from "../../../components/Public/Aspirante";
import { ModalAcademico } from "../../../components/Public/Aspirante";
import * as ducks from "../../../redux/aspirante/catalogoDucks";
//Imgs
import { ReactComponent as Libros } from "../../../assets/img/home/libros.svg";

/**
 * Pantalla que muestra la captura de los Requisitos Académicos del aspirante
 * @return {JSX.Element}
 */
export const InfoAcademicaPage = () => {
  const dispatch = useDispatch();
  window.scrollTo(0, 0);
  const [form] = Form.useForm();
  //Hook para controlar el modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { reqAcademicos } = useSelector((state) => state.aspirante.aspirante);
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );

  //Se cargan los catalogos
  useEffect(() => {
    dispatch(ducks.getAllCatalogos());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Función para mostrar/ocultar el modal de registro
   */
  const showModal = () => {
    setIsModalVisible((state) => !state);
  };
  return (
    <Layout>
      {/* Modal del formulario Req. Académico */}
      <ModalAcademico
        isModalVisible={isModalVisible}
        showModal={showModal}
        form={form}
      />
      <div className="site-layout-content">
        <div style={{ margin: "0px 50px 0px 50px" }}>
          {/* Historial Académico */}
          {reqAcademicos.length > 0 && (
            <div className="mt-50">
              <HisAcademico showModal={showModal} form={form} />
            </div>
          )}
          {/* Sin Datos */}
          {reqAcademicos.length === 0 && (
            <>
              <SinDatos />
              <div className="mt-50">
                <NuevoRegistro
                  showModal={showModal}
                  isDisable={bloquearPorFecha || estatusPostulacion}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};
/**
 * Componente
 * @param {function} showModal para mostrar el modal
 * @returns JSX
 */
export const NuevoRegistro = ({ showModal, isDisable = true }) => (
  <Button type="link" icon={<PlusCircleFilled />} disabled={isDisable} className="btn-nuevo">
    <span  onClick={showModal}>
      Agregar nueva escolaridad
    </span>
  </Button>
);

/**
 * Componente que muestra el mensaje cuando no hay información
 * @returns JSX
 */
export const SinDatos = () => (
  <Row gutter={24}>
    <div className="contenedor-sin-datos">
      <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={6}>
        <Libros width={"100%"} />
      </Col>
      <Col xxl={21} xl={21} lg={21} md={21} sm={24} xs={24}>
        <div className="text-sin-datos">
          Presiona <b>“Agregar nueva escolaridad”</b> para comenzar a agregar
          información de tu historial escolar.
        </div>
      </Col>
    </div>
  </Row>
);
